export default "__VITE_ASSET__DHlNQ6nz__"